import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@chilecompra/react-kit/components'
import { Airlines, Column, Row } from './HomeForm.styles'

/**
 * The AirlinesSection's component.
 */
const AirlinesSection = props => {
  const { children } = props
  return (
    <Airlines>
      <Row columnSpacing={{ md: 5 }} rowSpacing={5}>
        <Column xs={12}>
          <Typography fontWeight="bold" sx={{ mb: 4 }} variant="h2">
            Cotiza tarifas y realiza tu compra directamente en la aerolínea de tu elección
          </Typography>
          <Typography sx={{ maxWidth: 732 }} variant="body1">
            Cada uno de los proveedores de este Convenio Marco ha preparado un sitio especial para que realices la
            compra de tus pasajes aéreos nacionales.
          </Typography>
        </Column>
      </Row>
      {children}
    </Airlines>
  )
}

AirlinesSection.propTypes = {
  children: PropTypes.node.isRequired
}

export default AirlinesSection
